
import { LitEntity, html } from '../utility/lit-entity';
import './entity-note-list';
import './entity-note-save';

class SiteNotes extends LitEntity {
  constructor() {
    super();
    this.notesHref = '';
  }

  static get properties() {
    return {
      notesHref: { type: String, attribute: false },
      readonly: { type: Boolean },
    };
  }

  render() {
    return html`<entity-note-list .href="${this.notesHref}" ?readonly="${this.readonly}"></entity-note-list>`;
  }

  _entityChanged(entity) {
    super._entityChanged(entity);
    this.notesHref = this.entity?.getSubEntityByRel('https://api.binsentry.com/rel/notes')?.href || '';
  }
}

customElements.define('site-notes', SiteNotes);
